module.exports = __webpack_public_path__ + "img/car_s142.40672697.png";